/** Clases de layout para PortalSelect (el look lo define el componente). */
export const selectCls = "w-full";

/** Alias de ancho completo en formularios. */
export const selectClsLg = "w-full";
